<template>
  <div class="content">
    <div class="mod">
      <div class="box">
        <div class="bd">
          <div class="list">
            <img class="layer" src="static/img/7.png" data-src="static/img/7.png" alt="layer"/>
            <div class="row1">
              <img class="largeIcon" src="static/img/8.png" data-src="static/img/8.png" alt="largeIcon"/>
              <div class="outer_2">
                <div class="wrap">
                  <span class="text_2">萌宠</span>
                  <span class="txt">暖手宝&充电宝</span>
                </div>
                <span class="desc">礼品将在回款后为您寄出</span>
              </div>
              <img v-if="receive1 === false" @click="receivePrize(1)" class="largeIcon_1 icon" src="static/img/领取.png" data-src="static/img/领取.png" alt="largeIcon_1 icon">
              <img v-if="receive1 === true" class="largeIcon_1 icon" src="static/img/已领取.png" data-src="static/img/已领取.png" alt="largeIcon_1">
              <img v-if="grey1 === true" class="largeIcon_1 icon" src="static/img/领取灰.png" data-src="static/img/领取灰.png" alt="largeIcon_1">
            </div>
            <div class="row2">
              <img class="largeIcon_2" src="static/img/9.png" data-src="static/img/9.png" alt="largeIcon_2"/>
              <div class="outer_2">
                <div class="wrap">
                  <span class="text_2">G客</span>
                  <span class="txt">保温杯</span>
                </div>
                <span class="desc">礼品将在回款后为您寄出</span>
              </div>
              <img v-if="receive2 === false" @click="receivePrize(2)" class="largeIcon_1 icon" src="static/img/领取.png" data-src="static/img/领取.png" alt="largeIcon_1">
              <img v-if="receive2 === true" class="largeIcon_1 icon" src="static/img/已领取.png" data-src="static/img/已领取.png" alt="largeIcon_1">
              <img v-if="grey2 === true" class="largeIcon_1 icon" src="static/img/领取灰.png" data-src="static/img/领取灰.png" alt="largeIcon_1">
            </div>
            <div class="row3">
              <div class="container_3">
                <img class="largeIcon_3" src="static/img/4.png" data-src="static/img/4.png" alt="largeIcon_3"/>
              </div>
              <div class="outer_3">
                <div class="group_4">
                  <span class="txt_2">病毒</span>
                  <span class="word_3">800元</span>
                  <span class="text_4">优惠券</span>
                </div>
                <span class="desc_3">无门槛优惠券，有效期1个月</span>
              </div>
              <img v-if="receive3 === false" @click="receivePrize(3)" class="largeIcon_1 icon" src="static/img/领取.png" data-src="static/img/领取.png" alt="largeIcon_1">
              <img v-if="receive3 === true" class="largeIcon_1 icon" src="static/img/已领取.png" data-src="static/img/已领取.png" alt="largeIcon_1">
              <img v-if="grey3 === true" class="largeIcon_1 icon" src="static/img/领取灰.png" data-src="static/img/领取灰.png" alt="largeIcon_1">
            </div>
            <div class="row4">
              <div class="block_6">
                <img class="largeIcon_4" src="static/img/3.png" data-src="static/img/3.png" alt="largeIcon_4"/>
              </div>
              <div class="outer_4">
                <div class="group_4">
                  <span class="txt_2">蛋白组学</span>
                  <span class="word_3">1314元</span>
                  <span class="text_4">券</span>
                </div>
                <span class="desc_3">合同金额5万以上可使用</span>
              </div>
              <img v-if="receive4 === false" @click="receivePrize(4)" class="largeIcon_1 icon" src="static/img/领取.png" data-src="static/img/领取.png" alt="largeIcon_1">
              <img v-if="receive4 === true" class="largeIcon_1 icon" src="static/img/已领取.png" data-src="static/img/已领取.png" alt="largeIcon_1">
              <img v-if="grey4 === true" class="largeIcon_1 icon" src="static/img/领取灰.png" data-src="static/img/领取灰.png" alt="largeIcon_1">
            </div>
            <div class="row5">
              <div class="container_5">
                <div class="outer_5">
                  <img class="news" src="static/img/2.png" data-src="static/img/2.png" alt="news"/>
                </div>
              </div>
              <div class="outer_6">
                <span class="info_2">m6A高级生信分析券</span>
                <span class="info_3">满4个样本免费分析</span>
              </div>
              <img v-if="receive5 === false" @click="receivePrize(5)" class="largeIcon_1 icon" src="static/img/领取.png" data-src="static/img/领取.png" alt="largeIcon_1">
              <img v-if="receive5 === true" class="largeIcon_1 icon" src="static/img/已领取.png" data-src="static/img/已领取.png" alt="largeIcon_1">
              <img v-if="grey5 === true" class="largeIcon_1 icon" src="static/img/领取灰.png" data-src="static/img/领取灰.png" alt="largeIcon_1">
            </div>
          </div>
          <div class="item">
            <span class="text_6">活动规则</span>
            <span class="article">
              1、所选礼品在您该笔订单回款后5个工作日内安排发货。<br>
              2、m6A高级生信分析券，满4个样本的m6A测序合同，签订且到样后即可使用，有效期至2021年2月28日。可添加专属客服：jikaikefu使用该券。<br>
              3、蛋白组学1314元代金券，限合同目录价金额大于5万的蛋白组学合同使用，在目录价上抵扣，有效期至2021年2月28日。可添加专属客服：jikaikefu使用该券。<br>
              4、病毒代金券有效期自领取12小时后起1个月内有效，所有病毒都可使用。限在淘基因商城下单，该代金券可叠加日常折扣使用。<br>
              5、该折扣优惠与其他优惠券和会员折扣不同享。
            </span>
          </div>
          <div class="group_6">
            <div class="tagWrap">
              <span class="tag" @click="goHome">
                返回首页
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { mapState, mapGetters } from 'vuex'
  import Emkt from '../../emkt'
  import wx from 'wx'

  export default {
    mounted () {
    },
    computed: {
      ...mapState([
        'sessionInfo', 'myOrder', 'showLotteryAlready'
      ]),
      ...mapGetters([
        'hasLogin', 'customerName'
      ])
    },
    data () {
      return {
        receive1: false,
        receive2: false,
        receive3: false,
        receive4: false,
        receive5: false,
        grey1: false,
        grey2: false,
        grey3: false,
        grey4: false,
        grey5: false,
        BCoupon: {},
        prizes: {
          1: {
            name: '萌宠暖手宝&充电宝',
            type: Emkt.PRIZE_TYPE_OBJECT
          },
          2: {
            name: 'G客保温杯',
            type: Emkt.PRIZE_TYPE_OBJECT
          },
          3: {
            name: '病毒800元优惠券',
            type: Emkt.PRIZE_TYPE_COUPON,
            BCoupon: { promotionGuid: 'coupon-20201214-001', code: '2021bingdu-800', startDT: this.getHours(0), endDT: this.getDay(30) }
          },
          4: {
            name: '蛋白组学1314元券',
            type: Emkt.PRIZE_TYPE_COUPON,
            BCoupon: { promotionGuid: 'coupon-20201231-001', code: '2021danbai', startDT: this.getDay(0), endDT: '2021-02-28 23:59:59' }
          },
          5: {
            name: 'm6A高级生信分析券',
            type: Emkt.PRIZE_TYPE_COUPON,
            BCoupon: { promotionGuid: 'coupon-20201231-002', code: '2021m6A', startDT: this.getDay(0), endDT: '2021-02-28 23:59:59' }
          }
        },
        PrizeDetailBO: {}
      }
    },
    methods: {
      goHome () {
        if (this.receive1 === false && this.receive2 === false && this.receive3 === false && this.receive4 === false && this.receive5 === false) {
          this.$weui.dialog({
            title: '',
            content: '您确定放弃领取奖品吗',
            buttons: [{
              label: '取消',
              type: 'default',
              onClick: () => {
              }
            }, {
              label: '确定',
              type: 'primary',
              onClick: () => {
                this.revert()
              }
            }]
          })
        } else {
          this.revert()
        }
      },
      revert () {
        if (Emkt.isWapp) {
          wx.miniProgram.switchTab({
            url: '/pages/index/index'
          })
        } else {
          this.$router.replace({ name: 'home' })
        }
      },
      getDay (day) {
        var date = new Date()
        var milliseconds = date.getTime() + 1000 * 60 * 60 * 24 * day
        date.setTime(milliseconds)

        var currentYear = date.getFullYear()
        var currentMonth = date.getMonth()
        var currentDate = date.getDate()
        var currentHours = date.getHours()
        var currentMinutes = date.getMinutes()
        var currentSeconds = date.getSeconds()
        currentMonth = this.doHandleMonth(currentMonth + 1)
        currentDate = this.doHandleMonth(currentDate)
        return currentYear + '-' + currentMonth + '-' + currentDate + ' ' + currentHours + ':' + currentMinutes + ':' + currentSeconds
      },
      doHandleMonth (month) {
        var m = month
        if (month.toString().length === 1) {
          m = '0' + month
        }
        return m
      },
      getHours () {
        let timestamp = new Date().getTime()
        timestamp = timestamp + 12 * 60 * 60 * 1000
        var dateAfter = new Date(timestamp)
        var tempTimeStr24 = dateAfter.toLocaleTimeString('chinese', { hour12: false })
        return dateAfter.getFullYear() + '-' + (dateAfter.getMonth() + 1) + '-' + dateAfter.getDate() + ' ' + tempTimeStr24
      },
      receivePrize (id) {
        if (id === 1) {
          this.$weui.dialog({
            title: '「是否确认领取礼品？」',
            content: '萌宠暖手宝&充电宝，所选礼品将在您该笔订单回款后5个工作日内安排寄出。',
            buttons: [{
              label: '取消',
              type: 'default',
              onClick: () => {
              }
            }, {
              label: '确定',
              type: 'primary',
              onClick: () => {
                this.subLottery(id)
              }
            }]
          })
        } else if (id === 2) {
          this.$weui.dialog({
            title: '「是否确认领取礼品？」',
            content: 'G客保温杯礼品，所选礼品将在您该笔订单回款后5个工作日内安排寄出。',
            buttons: [{
              label: '取消',
              type: 'default',
              onClick: () => {
              }
            }, {
              label: '确定',
              type: 'primary',
              onClick: () => {
                this.subLottery(id)
              }
            }]
          })
        } else if (id === 3) {
          this.$weui.dialog({
            title: '「是否确认领取礼品？」',
            content: '病毒800元代金券有效期自领取12小时后起1个月内有效，所有病毒都可使用。<br> 限在淘基因商城下单，该代金券可叠加日常折扣使用。',
            buttons: [{
              label: '取消',
              type: 'default',
              onClick: () => {
              }
            }, {
              label: '确定',
              type: 'primary',
              onClick: () => {
                this.subLottery(id)
              }
            }]
          })
        } else if (id === 4) {
          this.$weui.dialog({
            title: '「是否确认领取礼品？」',
            content: '蛋白组学1314元代金券，限合同目录价金额大于5万的蛋白组学合同使用，在目录价上抵扣，有效期至2021年2月28日。',
            buttons: [{
              label: '取消',
              type: 'default',
              onClick: () => {
              }
            }, {
              label: '确定',
              type: 'primary',
              onClick: () => {
                this.subLottery(id)
              }
            }]
          })
        } else {
          this.$weui.dialog({
            title: '「是否确认领取礼品？」',
            content: 'm6A高级生信分析券，满4个样本的m6A测序合同，签订且到样后即可使用，有效期至2021年2月28日。',
            buttons: [{
              label: '取消',
              type: 'default',
              onClick: () => {
              }
            }, {
              label: '确定',
              type: 'primary',
              onClick: () => {
                this.subLottery(id)
              }
            }]
          })
        }
      },
      subLottery (id) {
        var _this = this
        var objectPrizes = []
        var couponPrizes = []
        const selectedPrize = this.prizes[id]
        if (selectedPrize.type === Emkt.PRIZE_TYPE_OBJECT) {
          objectPrizes.push(selectedPrize.name)
          this.PrizeDetailBO = {
            'orderId': _this.$route.query.BOrders[0].id,
            'activityName': Emkt.activityName,
            'promotionGuid': Emkt.promotionGuid,
            'objectPrizes': objectPrizes
          }
        }
        if (selectedPrize.type === Emkt.PRIZE_TYPE_COUPON) {
          couponPrizes.push(selectedPrize.BCoupon)
          this.PrizeDetailBO = {
            'orderId': _this.$route.query.BOrders[0].id,
            'activityName': Emkt.activityName,
            'promotionGuid': Emkt.promotionGuid,
            'couponPrizes': couponPrizes
          }
        }
        this.gcapi('requestPrize', this.PrizeDetailBO).then((response) => {
          if (response.body.result === true) {
            if (id === 1) {
              this.receive1 = true
              this.grey2 = true
              this.grey3 = true
              this.grey4 = true
              this.grey5 = true
            } else if (id === 2) {
              this.receive2 = true
              this.grey1 = true
              this.grey3 = true
              this.grey4 = true
              this.grey5 = true
            } else if (id === 3) {
              this.receive3 = true
              this.grey1 = true
              this.grey2 = true
              this.grey4 = true
              this.grey5 = true
            } else if (id === 4) {
              this.receive4 = true
              this.grey1 = true
              this.grey2 = true
              this.grey3 = true
              this.grey5 = true
            } else {
              this.receive5 = true
              this.grey1 = true
              this.grey2 = true
              this.grey3 = true
              this.grey4 = true
            }
          }
        })
      }
    }
  }
</script>
<style scoped>
  .mod {
    width: 100%;
    height: 1154px;
  }
  .mod .box {
    display: flex;
    position: relative;
    align-items: flex-start;
    flex-direction: column;
    background-color: #FAFAFA;
    width: 100%;
    height: 1154px;
    overflow: hidden;
  }
  .mod .bd {
    display: flex;
    position: relative;
    align-items: flex-start;
    flex-direction: column;
    background-image: linear-gradient(180deg, #FFBF79 0%, #FF9B7E 100%);
    width: 100%;
    height: 1154px;
  }
  .mod .list {
    display: flex;
    position: relative;
    align-items: center;
    flex-direction: column;
    margin-top: 10px;
    width: 100%;
    height: 667px;
    padding: 0px 10px;
  }
  .mod .layer {
    position: absolute;
    top: 0px;
    align-self: center;
    width: 375px;
    height: 667px;
  }
  .mod .row1 {
    display: flex;
    position: relative;
    align-items: center;
    flex-direction: row;
    margin-top: 212px;
    border-radius: 10px;
    background-color: #FFEEDD;
    width: 285px;
    height: 75px;
  }
  .mod .icon {
    position: absolute;
    right: 11px;
  }
  .mod .largeIcon {
    margin-right: 5px;
    margin-left: 5px;
    width: 68px;
    height: 65px
  }
  .mod .outer_2 {
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    height: 37px;
    margin-right: 22px;
  }
  .mod .wrap {
    display: flex;
    position: relative;
    align-items: center;
    flex-direction: row;
    height: 21px;
  }
  .mod .text_2 {
    line-height: 21px;
    color: #6c4c39;
    font-size: 15px;
    font-weight: 500;
  }
  .mod .txt {
    line-height: 21px;
    color: #e04626;
    font-size: 15px;
    font-weight: 500;
  }
  .mod .desc {
    position: relative;
    max-width: 195px;
    height: 16px;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 16px;
    color: #6c4c39;
    font-size: 11px;
    font-weight: 400;
  }
  .mod .row2 {
    display: flex;
    position: relative;
    align-items: center;
    flex-direction: row;
    margin-top: 15px;
    border-radius: 10px;
    background-color: #FFEEDD;
    width: 285px;
    height: 75px;
  }
  .mod .largeIcon_1 {
    width: 53px;
    height: 53px;
  }
  .mod .largeIcon_2 {
    margin-right: 5px;
    margin-left: 5px;
    width: 68px;
    height: 65px;
  }
  .mod .row3 {
    display: flex;
    position: relative;
    align-items: center;
    flex-direction: row;
    margin-top: 15px;
    border-radius: 10px;
    background-color: #FFEEDD;
    width: 285px;
    height: 75px;
  }
  .mod .container_3 {
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: center;
    margin-right: 5px;
    margin-left: 5px;
    background-color: rgba(216, 216, 216, 0.00);
    width: 68px;
    height: 65px;
    overflow: hidden;
  }
  .mod .largeIcon_3 {
    width: 56px;
    height: 56px;
    margin: 6px 6px 5px 4px;
  }
  .mod .outer_3 {
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    height: 38px;
    margin-right: 8px;
  }
  .mod .outer_4 {
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    height: 38px;
    margin-right: 26px;
  }
  .mod .group_4 {
    display: flex;
    position: relative;
    align-items: center;
    flex-direction: row;
    height: 21px;
  }
  .mod .txt_2 {
    line-height: 21px;
    color: #6c4c39;
    font-size: 15px;
    font-weight: 500;
  }
  .mod .word_3 {
    line-height: 21px;
    color: #e04626;
    font-size: 15px;
    font-weight: 500;
  }
  .mod .text_4 {
    line-height: 21px;
    color: #6c4c39;
    font-size: 15px;
    font-weight: 500;
  }
  .mod .desc_3 {
    position: relative;
    margin-top: 1px;
    line-height: 16px;
    color: #6c4c39;
    font-size: 11px;
    font-weight: 400;
  }
  .mod .row4 {
    display: flex;
    position: relative;
    align-items: center;
    flex-direction: row;
    margin-top: 15px;
    border-radius: 10px;
    background-color: #FFEEDD;
    width: 285px;
    height: 75px;
  }
  .mod .block_6 {
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: center;
    margin-right: 5px;
    margin-left: 5px;
    background-color: rgba(216, 216, 216, 0.00);
    width: 68px;
    height: 65px;
    overflow: hidden;
  }
  .mod .largeIcon_4 {
    width: 68px;
    height: 63px;
  }
  .mod .row5 {
    display: flex;
    position: relative;
    align-items: center;
    flex-direction: row;
    margin-top: 15px;
    border-radius: 10px;
    background-color: #FFEEDD;
    width: 285px;
    height: 75px;
  }
  .mod .container_5 {
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: center;
    margin-right: 5px;
    margin-left: 5px;
    background-color: rgba(216, 216, 216, 0.00);
    width: 68px;
    height: 65px;
  }
  .mod .outer_5 {
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: center;
    background-color: rgba(216, 216, 216, 0.00);
    width: 50px;
    height: 48px;
    overflow: hidden;
  }
  .mod .news {
    width: 50px;
    height: 48px;
  }
  .mod .outer_6 {
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    height: 38px;
    margin-right: 15px;
  }
  .mod .info_2 {
    position: relative;
    max-width: 195px;
    height: 21px;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 21px;
    color: #6c4c39;
    font-size: 15px;
    font-weight: 500;
  }
  .mod .info_3 {
    position: relative;
    margin-top: 1px;
    max-width: 195px;
    height: 16px;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 16px;
    color: #6c4c39;
    font-size: 11px;
    font-weight: 400;
  }
  .mod .item {
    align-items: center;
    max-width: 341px;
    width: 300px;
    margin: 0 auto;
    margin-top: -20px;
  }

  .mod .text_6 {
    position: relative;
    margin-top: 35px;
    max-width: 341px;
    height: 17px;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 17px;
    color: #6c4c39;
    font-size: 12px;
    font-weight: 400;
    display: inline-block;
  }
  .mod .article {
    margin-top: 10px;
    width: 312px;
    line-height: 20px;
    color: #6c4c39;
    font-size: 12px;
    font-weight: 400;
    font-family: PingFangSC-Regular, PingFang SC;
    height: 235px;
    display: inline-block;
  }
  .mod .group_6 {
    box-shadow: 0 -2px 20px 0 rgba(0, 0, 0, 0.10);
    display: flex;
    position: fixed;
    align-items: center;
    flex-direction: column;
    margin-top: 120px;
    background-color: #FF9B7E;
    width: 100%;
    height: 96px;
    bottom: 0;
  }
  .mod .tagWrap {
    display: flex;
    position: relative;
    align-items: center;
    flex-direction: row;
    justify-content: center;
    margin-top: 15px;
    border-radius: 22px;
    background-image: linear-gradient(90deg, #F27C4E 0%, #E04626 100%);
    width: 355px;
    height: 44px;
  }
  .mod .tag {
    max-width: 343px;
    height: 20px;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 20px;
    color: #ffffff;
    font-size: 14px;
    font-weight: 400;
  }
</style>




// WEBPACK FOOTER //
// SuccessPay3.vue?5b3dbfea